import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "root" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "left" }, null, -1)),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "right" }, null, -1)),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.path
    }))
  ]))
}